/**
 * The studio's view of weekend room holds, and taking a room back (D-713).
 */

export type RoomHold = {
  stretchId: string
  teacher: string
  room: string
  /** "on Saturdays, 10:00 AM to 12:30 PM". */
  when: string
  /** Approved, or still waiting on an answer - both hold the room (D-711). */
  state: 'held' | 'waiting'
}

export const ROOM_HOLDS_KEY = ['room-holds'] as const

export async function fetchRoomHolds(): Promise<RoomHold[]> {
  const res = await fetch('/api/holds')
  if (!res.ok) throw new Error(`Could not load the weekend holds (${res.status})`)
  return res.json()
}

/** Takes the room back for one date, or for every date when none is given. */
export async function releaseRoomHold(stretchId: string, date: string | null, reason: string): Promise<void> {
  const res = await fetch(`/api/holds/${stretchId}/release`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ date, reason: reason.trim() || null }),
  })

  if (!res.ok) {
    const problem = await res.json().catch(() => null)
    throw new Error(problem?.detail ?? problem?.title ?? `Could not take the room back (${res.status})`)
  }
}
